export const INCREMENTARAFN = '[NumeroEnProcceso] Incrementar';
export const PROCESSO = '[NumeroEnProcesso] Processo';
export const GUARDAR_USER = '[Guardar user] User';
export const GUARDAR_PARAMS = '[Guardar parametrosGenerales] ParametrosGenerales';
export const GUARDAR_TURN = '[Guardar turno] Turno';
export const PRODUCTS_SUCCESS = 'search products success';
export const PRODUCTS_SALE = '[Gestionar venta] venta por usuario';
export const PRODUCTS_SALE_EDIT = '[Gestionar actualización de la venta] venta por usuario actualizar';
export const PRODUCTS_SELECTS = '[Gestionar produtos seleccionados] productos seleccionado en la venta';
export const PRODUCTS_SEARCH = '[Gestionar produtos seleccionar un turno] productos seleccionado en la venta por turno';
export const PRODUCTS_SUCCESS_EDIT = 'actualizar products';
export const PRODUCTS = 'search products success all';
export const ORDER_SELECT = 'search order select';
export const CLIENTS_SUCCESS = 'search all client';
export const CLIENT_SUCCESS = 'search one client';
export const UNSET_PRODUCTOS = '[Eliminar productos] UnSet productos';


// WEBPACK FOOTER //
// ./src/pages/meseromesero/state/productos/productos.types.ts